<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M12 3L3 8L12 13L21 8L12 3Z"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <path
    d="M3 12L12 17L21 12"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <path
    d="M3 16L12 21L21 16"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
</svg>
